<template>
    <div v-if="preloader === true">
        <template>
        <v-dialog v-model="preloader" hide-overlay persistent width="300">
            <v-progress-linear indeterminate></v-progress-linear>
        </v-dialog>
        </template>
    </div>

    <div v-else>
        <div v-if="displayNoData" class="mainDiv">
            <v-card 
                class="card"  flat color="transparent">
                <v-card-title>
                    No Demo Data Available
                </v-card-title>      
            </v-card>
        </div>
        <div class="w-100" v-else>
            <template v-if="!isMobile">
            <v-card height="64px" width="100%"
                class="background ml-4 mr-6 my-0 px-4 transparent elevation-0 d-flex flex-column justify-space-between align-center fix-top-width"
                style="position:fixed; z-index:200; top:0; padding-top: 16px;">
                <div class="d-flex background fix-top-width" >
                    <v-card-title class="pl-0 ml-0">
                    <p class="breadcrumb-text-unselected underline-on-hover cursor" @click="$router.push('/campaign')">
                        Campaigns
                    </p>
                    <v-icon class="breadcrumb-arrow-unselected"
                        style="margin-top: 6px !important">mdi-chevron-right</v-icon>
                    <p class="breadcrumb-text-unselected underline-on-hover cursor" @click="goBack">
                        {{ this.campaignName }}
                    </p>

                    <v-icon class="breadcrumb-arrow-unselected"
                        style="margin-top: 6px !important">mdi-chevron-right</v-icon>
                    <p class="breadcrumb-text" style="margin-top: 2px">Test Report</p>
                    <v-icon class="breadcrumb-arrow" style="margin-top: 5px !important">mdi-chevron-down</v-icon>
                </v-card-title>
                </div>
                <UserNavMenu/>
                <div class="d-flex background flex-column pr-12 fix-top-width">
                    <div class="d-flex justify-space-between align-center pr-16">
                    <span class="d-flex"><h3 class="ml-4">{{ this.personalDetails.name }} - Demo Analytics</h3> </span> 
                     <div class="d-flex background">
                        <TestToggleComponent @testChange="switchResult($event)" :buttons="stages" :isSelect="stagesIndex"> </TestToggleComponent>
                    </div>
                </div>
                <div class="d-flex mx-4">
                    <span>Demo Submitted On:</span> <span class="font-weight-bold">{{getDemoSubmittedDate ?? 'invalid date'}}</span>
                </div>
                </div>
            </v-card>

            <div class="analyticsPage">
                <div height="136px" class="mt-4">
                    <v-card outlined class="rounded-xl">
                        <v-row class="mx-1" >
                            <v-col
                            sm="4"
                            >
                            <v-row>
                                <v-col sm="2" class="pt-6">
                                   <v-avatar rounded  height="61" width="61"  class="mt-8" v-if="personalDetails?.picture">
                                    <v-img class="rounded-circle" :src="personalDetails?.picture" alt="User Pic"></v-img>
                                </v-avatar>
                                <v-avatar rounded class="mt-8" height="61" width="61" v-else>
                                    <v-img class="rounded-circle" src="../assets/avtar.png" alt="User Pic"></v-img>
                                </v-avatar> 
                                </v-col>
                                <v-col sm="10" class="mt-8 pt-6">
                                <v-row>
                                    <v-col sm=4>
                                      <p class="text-uppercase user-profile-text">Name: </p>
                                      <p class="text-uppercase user-profile-text">Email Id: 
                                      </p>
                                        <p class="text-uppercase user-profile-text">Phone Number: 
                                        </p>
                                    </v-col>
                                    <v-col sm=8>
                                      <p class="text-body-2">{{ this.personalDetails.name }}</p>
                                      <p v-if="this.personalDetails.email" class="text-body-2 text-uppercase elipsis">{{ this.personalDetails.email }}</p>
                                      <p v-else class="text-body-2 text-uppercase">-</p>
                                      <p v-if="this.personalDetails.phoneNo" class="text-body-2 text-uppercase">{{ this.personalDetails.phoneNo }}</p>
                                      <p v-else class="text-body-2 text-uppercase">-</p>  
                                    </v-col>
                                </v-row>
                                    
                                </v-col>
                            </v-row>
                            
                            <!-- <div class="ml-8 flex-1 demo-text">
                                
                            </div> -->
  
                            </v-col>
                            <v-divider
                              vertical
                              class="mt-10 mb-6"
                            ></v-divider>
                            <v-col
                            sm="8"
                            >
                            <span class="ml-2 score-text" >AVERAGE SCORE </span>
                                <v-row>
                                    <v-col
                                    v-for="(demo, key) in cumulativeDemoTest" :key="key"
                                    align="center"
                                    sm="3"
                                    class="px-0 ">
                                    <v-card
                                            class="pa-2 ma-2 rounded-xl"
                                              outlined
                                              tile

                                              
                                            >
                                            <v-progress-circular
                                            class="v-progress-circular__overlay"
                                            :value="demo"
                                            :rotate="-90"
                                            :size="80"
                                            :width="8"
                                            min="0"
                                            max="10"
                                            :color="getCircleColor(demo)">
                                                <span class="small-circular-progress-inner-outer-text">{{ Number.isInteger(demo/10) ? demo/10 : (demo / 10).toFixed(2) ?? 0}}  / 10</span>
                                            </v-progress-circular>
                                            <p class="mt-2 small-circular-progress-inner-outer-text">{{key.replaceAll('_', ' ')}}</p>
                                            </v-card>
                                        
                                    </v-col>      
                                </v-row>  
                            </v-col>
                        </v-row>
                    </v-card>
                </div>

                 
                <div class="lowerDiv">
                    <v-tabs
                    class="demo-segmented-control"
                      v-model="selectedtabIndex"
                      background-color="#3F41D114"
                      color="#000000"
                      active-class="active-subject-tab"
                      grow
                    >
                      <v-tab
                        v-for="(demoTest, index) in cumulativeTestArray"
                        :key="index"
                      >
                        <div class="d-flex flex-column align-center">
                          <span>{{ demoTest.name.toUpperCase() }}</span>
                          <span class="caption">{{ demoTest.topicName }}</span>
                        </div>
                      </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="selectedtabIndex">
                        <v-tab-item
                        v-for="(demoTest, index) in cumulativeTestArray"
                        :key="index"
                        > 
                        <v-row class="mx-1">
                            <v-col  cols="5" class="px-0" >
                                <v-card
                                class="pa-3 rounded-xl mt-4 mx-4" 
                                outlined
                                tile 
                                >
                                    <div class="d-flex align-center"> 
                                        <div class="video-wrapper pt-2">
                                         <video :key="demoTest.videoData?.videoUrl" ref="video"  width="109"   class="pt-2 thumbnain-ht" controlslist="nodownload noremoteplayback" preload="auto" disablepictureinpicture :poster="demoTest.videoData?.thumbnailUrl" @ended="reloadVid">
                                            <source :src="demoTest.videoData?.videoUrl" type="video/mp4">
                                            Your browser does not support the video tag.
                                        </video>  
                                    
                                        <v-btn icon class="play-button">
                                            <img
                                            src="@/assets/u_play.svg"
                                            alt="Play"
                                            @click="openLargeScreen(demoTest)"
                                            style="width: 24px; height: 24px;"
                                            />
                                        </v-btn>
                                        
                                        
                                        </div>
                                        <div
                                         >
                                        <div class="d-flex align-center pl-3">
                                            <div>
                                            <p class="text-uppercase user-profile-text">Video Name: </p>
                                            <p class="text-uppercase user-profile-text">Duration:
                                            </p> 
                                            </div>
                                            <div>
                                                <v-tooltip bottom style="z-index: 999">
                                                <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                    <p style="max-width: 20vw" class="text-body-2 elipsis">{{ demoTest.videoData?.videoName }} </p>
                                                </span>
                                                </template>
                                                <span>{{ demoTest.videoData?.videoName }}</span>
                                            </v-tooltip>
                                              <p class="text-body-2">{{ getTime(demoTest.videoData?.duration)
                                            }} </p>  
                                            </div>
                                        </div>
                                            
                                        </div>

                                    </div>

                                </v-card>
                                <v-card

                                class="pa-2 ma-4 rounded-xl" 
                                outlined
                                tile
                                >
                                <span class="demo-text">Cumulative Graph</span>
                                   <MultiLayerRadarChart  :chartData="demoTest.radarchart" :id="index"/>

                                </v-card>
                            </v-col>
                            <v-col cols="7" class="px-0">
                               
                                    <v-card class="ml-2 pt-4">
                                    <span class="demo-text">Individual Score</span>
                                    
                                        <v-row >

                                            <v-col
                                            class="px-0"
                                            sm="3"
                                            align="center"
                                            
                                            >
                                                <v-card
                                            class="d-flex justify-center align-center pa-3 ma-3
                                            rounded-xl mb-0"
                                                outlined
                                                tile
                                                
                                            >
                                            <div class="d-flex flex-column align-center">
                                            <v-progress-circular
                                            class="v-progress-circular__overlay"
                                            :value=demoTest.knowledgeLevel
                                            :rotate="-90"
                                                :size="80"
                                            :width="8"
                                            min="0"
                                            max="10"
                                            :color="getCircleColor(demoTest.knowledgeLevel)">
                                                <span class="small-circular-progress-inner-outer-text ">{{
                                                Number.isInteger(demoTest.knowledgeLevel/10) ? demoTest.knowledgeLevel/10 : (demoTest.knowledgeLevel / 10).toFixed(2) ?? 0}}  / 10</span>
                                            </v-progress-circular>
                                            <p class="mt-2 small-circular-progress-inner-outer-text">Knowledge Score</p>
                                            </div>
                                            </v-card>
                                            </v-col>
                                            <v-col
                                            class="px-0"
                                            sm="3"
                                            align="center"

                                            >
                                                <v-card
                                            class="pa-3 ma-3 
                                            mb-0 rounded-xl d-flex justify-center align-center"
                                                outlined
                                                tile
                                            
                                            >
                                            <div class="d-flex flex-column align-center">
                                            <v-progress-circular
                                            class="v-progress-circular__overlay"
                                            :value=demoTest.confidenceLevel
                                            :rotate="-90"
                                            :size="80"
                                            :width="8"
                                            min="0"
                                            max="10"
                                            :color="getCircleColor(demoTest.confidenceLevel)">
                                                <span class="small-circular-progress-inner-outer-text">{{
                                                Number.isInteger(demoTest.confidenceLevel/10) ? demoTest.confidenceLevel/10 : (demoTest.confidenceLevel / 10).toFixed(2) ?? 0}}  / 10</span>
                                            </v-progress-circular>
                                            <p class="mt-2 small-circular-progress-inner-outer-text">Confidence Score</p>
                                            </div>
                                            </v-card>
                                            </v-col>
                                            <v-col
                                            class="px-0"
                                            sm="3"fullScreenVideo
                                            align="center"

                                            >
                                                <v-card
                                            class="pa-3 ma-3 
                                            mb-0 rounded-xl d-flex justify-center align-center"
                                                outlined
                                                tile
                                                
                                            >
                                            <div class="d-flex flex-column align-center">
                                            <v-progress-circular
                                            class="v-progress-circular__overlay"
                                            :value=demoTest.behaviorlLevel
                                            :rotate="-90"
                                                :size="80"
                                            :width="8"
                                            min="0"
                                            max="10"
                                            :color="getCircleColor(demoTest.behaviorlLevel)">
                                                <span class="small-circular-progress-inner-outer-text ">{{
                                                Number.isInteger(demoTest.behaviorlLevel/10) ? demoTest.behaviorlLevel/10 : (demoTest.behaviorlLevel / 10).toFixed(2) ?? 0}}  / 10</span>
                                            </v-progress-circular>
                                            <p class="mt-2 small-circular-progress-inner-outer-text">Behavioral Score</p>
                                            </div>
                                            </v-card>
                                            </v-col>
                                            <v-col
                                            class="pl-0"
                                            sm="3"
                                            align="center"

                                            >
                                                <v-card
                                            class="pa-3 ma-3 
                                            mb-0 rounded-xl d-flex justify-center align-center"
                                                outlined
                                                tile
                                                
                                            >
                                            <div class="d-flex flex-column align-center">
                                            <v-progress-circular
                                            class="v-progress-circular__overlay"
                                            :value=demoTest.fluencyLevel
                                            :rotate="-90"
                                            :size="80"
                                            :width="8"
                                            min="0"
                                            max="10"
                                            :color="getCircleColor(demoTest.fluencyLevel)">
                                                <span class="small-circular-progress-inner-outer-text ">{{
                                                Number.isInteger(demoTest.fluencyLevel/10) ? demoTest.fluencyLevel/10 : (demoTest.fluencyLevel / 10).toFixed(2) ?? 0}}  / 10</span>
                                            </v-progress-circular>
                                            <p class="mt-2 small-circular-progress-inner-outer-text">Fluency Score</p>
                                            </div>
                                            </v-card>
                                            </v-col>
                                        </v-row>
                                        <!-- <div class="d-flex justify-space-between my-3 align-center">
                                            <p class="league-title pt-2" v-if="roundComments.length> 0">Interviewer’s Remark</p> 
                                            <v-btn-toggle
                                            v-if="!commentsLoading"
                                                v-model="roundToggleIndex"
                                                mandatory
                                                dense
                                                rounded
                                                @change="updateRoundFeedback"
                                            >
                                                <v-btn
                                                v-for="(round, index) in rounds"
                                                class="skill-btn"
                                                :class="
                                                roundToggleIndex == index
                                                ? 'gray-05 blue--text caption white'
                                                : 'caption white'
                                                " :key="round"
                                                >
                                                Round {{ round }}
                                                </v-btn>
                                            </v-btn-toggle>
                                        </div> -->
                                        
                                        
                        <!-- <v-container class="pa-0" v-if="roundComments.length > 0">
                        <v-row class="pa-0" >
                            <v-col cols="4" class="pl-0" v-for="(interview, index) in roundComments" :key="index">
                                <v-card class="h-100 rounded-l" elevation="1" outlined >
                                    <div class="pa-4">
                                    <div class="interviewer-name">
                                        <v-tooltip top >
                                            <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on">
                                                {{interview.interviewerEmail ? interview.interviewerEmail : '---' }}
                                            
                                            </span>
                                            </template>
                                            <div >{{interview.interviewerEmail ? interview.interviewerEmail : '---' }}</div>
                                        </v-tooltip>
                                        </div>
                        
                                    <div class="interview-remark">   {{interview.comment | strippedContent}}  
                                    </div>
                                    </div>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-card width="100%" class="rounded-l mt-3" outlined  v-else>
                            <div class="d-flex justify-center align-center">
                        <p class="league-title pa-12">Interviewer’s remark data not available</p>
                        </div>
                    </v-card>    -->
                    
                                    </v-card> 
                                
                            </v-col> 
                        </v-row>
                        </v-tab-item>
                    </v-tabs-items>


                </div>


            </div>
            </template>

            <template v-if="isMobile">
              <div class="mobile-test-report-sticky-header">
              <div class="mobile-test-report-header d-flex align-center px-4">
                <v-btn icon large class="mr-1" @click="goBack">
                  <v-icon size="28">mdi-arrow-left</v-icon>
                </v-btn>
                <div class="text-h6 font-weight-bold">Test Report</div>
              </div>
              <v-tabs
                :value="stagesIndex"
                class="mobile-test-report-tabs"
                show-arrows
                hide-slider
                @change="switchResult($event)"
              >
                <v-tab
                  v-for="(btn, index) in mobileStageButtons"
                  :key="btn.status || index"
                  :disabled="btn.disable"
                >
                  {{ btn.status }}
                </v-tab>
              </v-tabs>

              <v-card class="mobile-candidate-card mx-4 mt-3 pa-4 rounded-xl" outlined elevation="0">
                <p class="font-weight-bold text-h6 mb-0">{{ personalDetails.name }}</p>
                <p class="subtitle-2 mb-0">{{ personalDetails.email }}</p>
              </v-card>
              </div>

              <div class="mobile-report-body ">
              <div class="mobile-avg-score-card mx-4 mt-3 ">
                <div class="text-subtitle-1 font-weight-bold mb-2">Average Score</div>
                <div class="mobile-score-gauge-grid">
                  <v-card
                    v-for="(demo, key) in cumulativeDemoTest"
                    :key="key"
                    class="pa-3 rounded-xl mobile-score-gauge-card"
                    outlined
                    elevation="0"
                  >
                    <div class="d-flex flex-column align-center">
                      <v-progress-circular
                        :value="demo"
                        :rotate="-90"
                        :size="72"
                        :width="7"
                        min="0"
                        max="10"
                        :color="getCircleColor(demo)"
                      >
                        <span class="mobile-gauge-text">{{ Number.isInteger(demo/10) ? demo/10 : (demo / 10).toFixed(2) ?? 0 }} / 10</span>
                      </v-progress-circular>
                      <p class="mt-2 mobile-gauge-label">{{ key.replaceAll('_', ' ') }}</p>
                    </div>
                  </v-card>
                </div>
              </div>

              <div v-if="cumulativeTestArray.length > 0" class="mobile-subject-toggle px-4 mt-3">
                <v-btn
                  v-for="(demoTest, index) in cumulativeTestArray"
                  :key="index"
                  outlined
                  rounded
                  class="mobile-subject-pill mr-2 mb-2"
                  :class="{ 'mobile-subject-pill--active': selectedtabIndex === index }"
                  @click="selectedtabIndex = index"
                >
                  {{ demoTest.name }}
                </v-btn>
              </div>

              <template v-if="cumulativeTestArray[selectedtabIndex]">
                <div class="px-4 mt-2 mobile-topic-name">{{ cumulativeTestArray[selectedtabIndex].topicName }}</div>

                <v-card class="mobile-video-card mx-4 mt-2 pa-3 rounded-xl d-flex align-center" outlined elevation="0">
                  <div class="mobile-video-thumb-wrapper mr-3">
                    <video
                      :key="cumulativeTestArray[selectedtabIndex].videoData?.videoUrl"
                      width="80"
                      class="mobile-video-thumb"
                      controlslist="nodownload noremoteplayback"
                      preload="auto"
                      disablepictureinpicture
                      :poster="cumulativeTestArray[selectedtabIndex].videoData?.thumbnailUrl"
                    >
                      <source :src="cumulativeTestArray[selectedtabIndex].videoData?.videoUrl" type="video/mp4">
                    </video>
                    <v-btn icon small class="mobile-video-play-btn" @click="openLargeScreen(cumulativeTestArray[selectedtabIndex])">
                      <img src="@/assets/u_play.svg" alt="Play" style="width: 20px; height: 20px;" />
                    </v-btn>
                  </div>
                  <div class="mobile-video-info">
                    <div class="d-flex align-center">
                      <span class="text-caption mr-1">Video Name :</span>
                      <span class="text-body-2 font-weight-bold text-truncate mobile-video-name">{{ cumulativeTestArray[selectedtabIndex].videoData?.videoName }}</span>
                    </div>
                    <div class="d-flex align-center">
                      <span class="text-caption mr-1">Duration :</span>
                      <span class="text-body-2 font-weight-bold">{{ getTime(cumulativeTestArray[selectedtabIndex].videoData?.duration) }}</span>
                    </div>
                  </div>
                </v-card>

                <div class="mobile-avg-score-card mx-4 mt-3 mb-4">
                  <div class="text-subtitle-1 font-weight-bold mb-2">Individual Score</div>
                  <div class="mobile-score-gauge-grid">
                    <v-card class="pa-3 rounded-xl mobile-score-gauge-card" outlined elevation="0">
                      <div class="d-flex flex-column align-center">
                        <v-progress-circular
                          :value="cumulativeTestArray[selectedtabIndex].knowledgeLevel"
                          :rotate="-90"
                          :size="72"
                          :width="7"
                          min="0"
                          max="10"
                          :color="getCircleColor(cumulativeTestArray[selectedtabIndex].knowledgeLevel)"
                        >
                          <span class="mobile-gauge-text">{{ Number.isInteger(cumulativeTestArray[selectedtabIndex].knowledgeLevel/10) ? cumulativeTestArray[selectedtabIndex].knowledgeLevel/10 : (cumulativeTestArray[selectedtabIndex].knowledgeLevel / 10).toFixed(2) ?? 0 }} / 10</span>
                        </v-progress-circular>
                        <p class="mt-2 mobile-gauge-label">Knowledge Score</p>
                      </div>
                    </v-card>
                    <v-card class="pa-3 rounded-xl mobile-score-gauge-card" outlined elevation="0">
                      <div class="d-flex flex-column align-center">
                        <v-progress-circular
                          :value="cumulativeTestArray[selectedtabIndex].confidenceLevel"
                          :rotate="-90"
                          :size="72"
                          :width="7"
                          min="0"
                          max="10"
                          :color="getCircleColor(cumulativeTestArray[selectedtabIndex].confidenceLevel)"
                        >
                          <span class="mobile-gauge-text">{{ Number.isInteger(cumulativeTestArray[selectedtabIndex].confidenceLevel/10) ? cumulativeTestArray[selectedtabIndex].confidenceLevel/10 : (cumulativeTestArray[selectedtabIndex].confidenceLevel / 10).toFixed(2) ?? 0 }} / 10</span>
                        </v-progress-circular>
                        <p class="mt-2 mobile-gauge-label">Confidence Score</p>
                      </div>
                    </v-card>
                    <v-card class="pa-3 rounded-xl mobile-score-gauge-card" outlined elevation="0">
                      <div class="d-flex flex-column align-center">
                        <v-progress-circular
                          :value="cumulativeTestArray[selectedtabIndex].behaviorlLevel"
                          :rotate="-90"
                          :size="72"
                          :width="7"
                          min="0"
                          max="10"
                          :color="getCircleColor(cumulativeTestArray[selectedtabIndex].behaviorlLevel)"
                        >
                          <span class="mobile-gauge-text">{{ Number.isInteger(cumulativeTestArray[selectedtabIndex].behaviorlLevel/10) ? cumulativeTestArray[selectedtabIndex].behaviorlLevel/10 : (cumulativeTestArray[selectedtabIndex].behaviorlLevel / 10).toFixed(2) ?? 0 }} / 10</span>
                        </v-progress-circular>
                        <p class="mt-2 mobile-gauge-label">Behavioral Score</p>
                      </div>
                    </v-card>
                    <v-card class="pa-3 rounded-xl mobile-score-gauge-card" outlined elevation="0">
                      <div class="d-flex flex-column align-center">
                        <v-progress-circular
                          :value="cumulativeTestArray[selectedtabIndex].fluencyLevel"
                          :rotate="-90"
                          :size="72"
                          :width="7"
                          min="0"
                          max="10"
                          :color="getCircleColor(cumulativeTestArray[selectedtabIndex].fluencyLevel)"
                        >
                          <span class="mobile-gauge-text">{{ Number.isInteger(cumulativeTestArray[selectedtabIndex].fluencyLevel/10) ? cumulativeTestArray[selectedtabIndex].fluencyLevel/10 : (cumulativeTestArray[selectedtabIndex].fluencyLevel / 10).toFixed(2) ?? 0 }} / 10</span>
                        </v-progress-circular>
                        <p class="mt-2 mobile-gauge-label">Fluency Score</p>
                      </div>
                    </v-card>
                  </div>
                </div>
              </template>
              </div>
            </template>

        </div>
        <v-dialog v-model="videoDialog" max-width="1217px"  @click:outside="stopVideo">
            <v-card>
                <div class="d-flex justify-space-between pa-3 ">
                    <p class="text-h6">Preview</p>
                    <v-icon class="icon-size" @click="videoDialog = false; stopVideo()">mdi-close</v-icon>
                </div>
                <v-card-text>
                <video
                ref="fullScreenVideo"
                class="w-100 preview-video"
                preload="auto"
                controls
                :src="expandVideoData.videoData?.videoUrl"
                @ended="reloadVid"
                ></video>
                </v-card-text>
    
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import AuthService from "../services/AuthService";
import ComputerVision from '../components/ComputerVision.vue'
import NlpAudio from '../components/NlpAudio.vue'
import { collection, doc, getDoc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase.js";
import CampaignController from '@/controllers/CampaignController';
import MultiLayerRadarChart from "../components/ReportGraphs/MultiLayerRadarChart.vue";
import { liveListenerUnsubscriber } from "@/mixins/liveListenerUnsubcriber";
import { getTime } from "../helpers/utils.js"
import TestToggleComponent from "@/components/ReportComponents/TestToggleComponent.vue";
import { mapGetters } from "vuex";
import UserNavMenu from "@/components/UserNavMenu.vue";

export default {
    mixins: [ liveListenerUnsubscriber ],
    data() {
        return {
            stages:[
                {status:'SCREENING', disable:true, },
                {status:'MAINS', disable: true,},
                {status: 'DEMO', disable: true},
                {status: 'INTERVIEW', disable:true}
            ],
            stagesIndex: 2,
            comments:[],
            preloader: true,
            search: "",
            videoDetails: {},
            selectedtabIndex: 0,
            activeVideoIndex: 0,
            radarChartData: {labels: [], datasets: [] },
            labels:['Behaviourl Level','fluency Level','Confidence Level','knowledge Level'],
            roundComments:[],
            cumulativeDemoTest: {
                "Knowledge_Score": 0,
                "Confidence_Score": 0,
                "Behavioral_Score": 0,
                "Fluency_Score": 0
            },
            roundToggleIndex:0,
            cumulativeTestArray:[],
            campaignName:"",
            campaignType: "",
            displayNoData:false,
            personalDetails:{
                name:'',
                phoneNo:'',
                email:'',
                picture:''
            },
            getTime,
            rounds: [],
            latestFeedbackRound: 1,
            commentsLoading: false,
            demoSubmittedOn: '',
            videoDialog:false,
            expandVideoData:{},
            numberOfRounds: [],
            currentTestRoundIndex: 0,
        }
    },
    filters: {
    strippedContent: function(string) {
           return string.replace(/<\/?[^>]+>/ig, " "); 
        },
        tofixRating: function(number){
        return number % 1 !== 0 || !Number.isInteger(number) ? number.toFixed(1) : number
        }
    },
    components: {
        ComputerVision,
        NlpAudio,
        MultiLayerRadarChart,
        TestToggleComponent,
        UserNavMenu
    },
    async mounted() {
        this.campaignId = this.$route.params.campaignId;
        this.userId = this.$route.params.userId;

        await this.getVideoDetails();
        this.getReportData();
        
        this.getCampaignDetails();
        // this.videoDetails=this.$route.params.videoDetails
        // console.log("videoDetails :", this.$route.params.videoDetails)
    },
    watch: {
    videoDialog(newVal) {
      if (newVal) {
        this.reloadVid()
      }
    }
    },
    methods: {
        reloadVid(){
               this.$nextTick(() => {
                    const video = this.$refs.fullScreenVideo;
                    if (video) {
                        video.currentTime = 0;   // optional: rewind to start
                        video.load();            // reloads the video and resets buffering
                    }
                    });
         
        },
        stopVideo() {
        const video = this.$refs.fullScreenVideo;
        if (video) {
            video.pause();
            video.currentTime = 0;
            video.load(); // <-- this forces the browser to reinitialize the video
        }
        },
        openLargeScreen(videoData) {
            this.expandVideoData = videoData
            this.videoDialog = true;
        },
        playVideo() {
            const videoEl = this.$refs.video;
            // Handle if ref is an array (common with v-for or Vue 2 behavior)
            const video = Array.isArray(videoEl) ? videoEl[0] : videoEl;

            if (video && video.play) {
                video.play();
            } else {
                console.warn('Video element not found or play is not available', video);
            }
        },
        updateRoundFeedback(){
         this.roundComments = this.comments.filter(({round})=> round == this.rounds[this.roundToggleIndex])
        },
        async getCampaignDetails(){
            const campaignRef = doc(db,"campaigns",this.campaignId);
            const campaignSnap = await getDoc(campaignRef);
            const campaignData = campaignSnap.data()
            this.campaignName = campaignData.name;
            this.campaignType = campaignData.audienceType;
            return campaignData
        },        

        logout() {
            AuthService.logout();
            this.$router.push("/login");
        },
        async getVideoDetails() {
            this.videoDetails = await this.setUserDemoVideoDetails()
            const demoVideos = this.videoDetails
            localStorage.setItem("videoInfo", JSON.stringify(demoVideos));
            this.$store.commit("setVideoDetails", demoVideos);
            this.preloader = false
        },
        switchResult(event){
            this.stagesIndex = event
            let page = this.stagesIndex <= 1 ? 'testreport' : this.stagesIndex == 3 ? 'interviewReport': ''
            if(this.stagesIndex !== 2){
                this.$router.push({ path: `/${page}/${this.campaignId}/${this.userId}`, query: { isSelect: this.stagesIndex, ...(this.$route.query.redirectedFrom && {redirectedFrom: this.$route.query.redirectedFrom}) } })
            }
         
        },
        async getReportData() {
            try {
                
                const response = await CampaignController.getReportData(this.userId, this.campaignId);
                console.log("jhgjgjf :", response.data);
                
                if (response.data?.result) {
                    const topicsMap = response.data.result.topicsForDemo.reduce((acc, topic) => {
                        acc[topic.subjectName.toLowerCase()] = topic.topicName;
                        return acc;
                    }, {});
                    
                    if(!response.data.result.demoTestChart){
                        this.displayNoData = true;
                    }
                    if(response.data?.result?.interViewFeedback?.length > 0){
                        this.commentsLoading = true;
                        this.comments = response.data?.result?.interViewFeedback.filter(item => item.comment && item.comment.trim() !== "")
                        this.rounds= [...new Set(this.comments.map(({round})=>round))];
                        this.latestFeedbackRound = Math.max(...this.rounds);
                        this.roundComments = this.comments.filter(({round})=> round == this.latestFeedbackRound)
                        this.roundToggleIndex = this.rounds.length - 1;
                        console.log('roundToggleIndexroundToggleIndexroundToggleIndex',this.roundToggleIndex )

                        this.commentsLoading = false;

                    }
                    
                    this.personalDetails.name = response.data?.result?.name;
                    this.personalDetails.email = response.data?.result?.email;
                    this.personalDetails.phoneNo = response.data?.result?.phone;
                    this.personalDetails.picture = response.data?.result?.proctoringPic;
                    this.cumulativeDemoTest.Knowledge_Score = response.data.result.cumulativeDemoTest.knowledgeLevel * 10;
                    
                    this.cumulativeDemoTest.Behavioral_Score = response.data.result.cumulativeDemoTest.behaviorlLevel * 10;
                    this.cumulativeDemoTest.Fluency_Score = response.data.result.cumulativeDemoTest.fluencyLevel * 10;
                    this.cumulativeDemoTest.Confidence_Score = response.data.result.cumulativeDemoTest.confidenceLevel * 10;
                    const { numberOfRounds, currentTestRoundIndex } = response.data?.result;
                    this.numberOfRounds = numberOfRounds || [];
                    this.currentTestRoundIndex = currentTestRoundIndex || 0;

                    if(numberOfRounds && numberOfRounds.length > 0 ){
                        numberOfRounds.forEach((item, index)=>{
                            if(index < currentTestRoundIndex){
                                this.stages.find((stage)=> stage.status == item.toUpperCase()).disable = false
                            }
                        })
                    }
                    response.data.result.demoTestChart.forEach(subject => {
                    var radarChartData = {
                        labels: ["Behavioral Score", "Fluency Score", "Confidence Score", "Knowledge Score"],
                        datasets: [{
                            label: 'Demo',
                            data: [subject.behaviorlLevel, subject.fluencyLevel, subject.confidenceLevel, subject.knowledgeLevel],
                            backgroundColor: "rgba(243, 248, 183, 0.8)",
                            borderColor: 'rgba(224, 237, 75, 1)',
                            pointBackgroundColor: 'rgb(255, 99, 132)',
                            pointRadius: 0,
                            pointBorderColor: '#586486',
                            pointHoverBackgroundColor: '#fff',
                            pointHoverBorderColor: 'rgb(255, 99, 132)'
                        }]
                    };  
                        let video;
                        console.log('details video',this.videoDetails.demovideos)
                        this.videoDetails.demovideos.forEach(videoObject => {
                            if(videoObject.subject == subject.name){
                                video = videoObject 
                                console.log('video',video)   
                            }
                        });
                        const subjectKey = subject.name.split(',')[0].trim().toLowerCase();

                        var subjectObj = {
                            name: subject.name,
                            topicName: topicsMap[subjectKey],
                            radarchart: radarChartData,
                            videoData : video,
                            behaviorlLevel: subject.behaviorlLevel * 10,
                            fluencyLevel: subject.fluencyLevel * 10,
                            confidenceLevel: subject.confidenceLevel * 10,
                            knowledgeLevel: subject.knowledgeLevel * 10
                        };
                        // Push subject object to cumulativeTestArray
                        this.cumulativeTestArray.push(subjectObj);
                    });
                    this.demoSubmittedOn = response.data.result?.demoSubmittedOn;
                
                          
                } else {
                    // alert(response.data.error);
                    console.log('response data error...', response.data.error)
                    alert("Something went wrong");
                }
            } catch (err) {
                console.log(err);
            } finally {
                this.preloader = false;
            }
        },
        goBack() {
            if (window.opener) {
                window.close();
            } else {
                this.$router.push({
                    path: "/campaignUser",
                    name: "CampaignUserView",
                    query: {
                        id: this.campaignId,
                        campaignType: this.campaignType,
                    },
                });
            }
        },

        loadNextSubject() {
            this.activeVideoIndex++
        },
        loadPrevSubject() {
            this.activeVideoIndex--
        },
        async setUserDemoVideoDetails() {
            const docRef = doc(db, 
                    "campaigns",
                    this.campaignId,
                    "audience",
                    this.userId);
            const docSnap = await getDoc(docRef);
            // console.log("demo video reference..??", videoRef)
            return new Promise((resolve) => {
                if (docSnap.exists()) {
                    console.log("Document data:", docSnap.data());
                    this.userData = docSnap.data();
                } else {
                    console.log("No such document!");
                    reject("No such document!")
                }
                const videoRef = collection(
                    db,
                    "campaigns",
                    this.campaignId,
                    "audience",
                    this.userId,
                    "demovideos"
                );
                
                const getUserDetailsForCampaign = async () => {
                    const userAudianceRef = doc(db, "campaigns", this.campaignId, "audience", this.userId);
                    const userAudianceSnap = await getDoc(userAudianceRef);
                    const userDetails = userAudianceSnap.data()
                    console.log('userDetails', userDetails.proctoringPic)
                    return userDetails.proctoringPic
                }
                getUserDetailsForCampaign()
                
                let unsubscribe = onSnapshot(videoRef, async (videoSnapshot) => {
                    this.dataDemoVideos = {
                        name: this.userData.personalInfo.firstName,
                        email: this.userData.personalInfo.contactInfo.email,
                        phoneNumber: this.userData.personalInfo.contactInfo.phoneNumber,
                        proctoringPic: await getUserDetailsForCampaign(),
                        demovideos: []
                    }
                    videoSnapshot.forEach((v) => {
                        const videoData = v.data();
                        const videoId = v.id;
                        this.dataDemoVideos.demovideos.push({
                            videoId: videoId,
                            ...videoData,
                        });
                    });

                    console.log(
                        "data demo videos after video snapshot...??",
                        this.dataDemoVideos
                    );
                    if(this.dataDemoVideos?.demovideos.length===0)  reject(this.dataDemoVideos?.demovideos)
                    resolve(this.dataDemoVideos)
                });
                this.liveListenersToUnsubscribeMixin.push(unsubscribe);
            })

        },
        getCircleColor(value) {

              if (value < 40) {
                return '#FF2600'; 
              } else if (value >= 40 && value < 60) {
                return '#E39236';  
              } else if (value >= 60 && value < 75) {
                return '#97AD39';  
              }else if (value >= 75 && value < 90) {
                return '#5f9C4A';  
              }else {
                return '#56905E'; 
              }
        }
    },
    // computed: {
    //     demovideos() {
    //         console.log(this.videoDetails.demovideos)
    //         return this.videoDetails.demovideos[this.activeVideoIndex];
    //     },
        computed: {
            getDemoSubmittedDate() {
            if(!this.demoSubmittedOn) return '';
            const date = new Date(this.demoSubmittedOn);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        },
        isMobile() {
            return this.$vuetify.breakpoint.smAndDown;
        },
        mobileStageButtons() {
            const list = this.stages.map((stage) => ({ ...stage }));
            if (this.numberOfRounds.length > 0) {
                this.numberOfRounds.forEach((item, index) => {
                    if (index < this.currentTestRoundIndex) {
                        const stage = list.find((s) => s.status === item.toUpperCase());
                        if (stage) stage.disable = false;
                    }
                });
            }
            const demoStage = list.find((s) => s.status === 'DEMO');
            if (demoStage) demoStage.disable = false;
            return list;
        }
        }
    // }
}
</script>
<style scoped>
.mobile-test-report-sticky-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: var(--white);
}
.mobile-test-report-header {
  height: 64px;
}
.mobile-test-report-tabs {
  margin: 0 4px;
}
.mobile-test-report-tabs ::v-deep .v-tab--active,
.mobile-test-report-tabs ::v-deep .v-tab--active.v-tab--disabled {
  color: var(--blue-01) !important;
  box-shadow: inset 0 -2px 0 0 var(--blue-01);
}
.mobile-candidate-card {
  border: 1px solid var(--gray-03);
}
.mobile-report-body {
  background: var(--white);
  padding-bottom: 16px;
}
.mobile-avg-score-card {
  background: var(--white);
  padding: 12px;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
}
.mobile-score-gauge-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.mobile-score-gauge-card {
  border: 1px solid var(--gray-03);
}
.mobile-score-gauge-card:nth-child(odd) {
  margin-left: 8px;
}
.mobile-score-gauge-card:nth-child(even) {
  margin-right: 8px;
}
.mobile-score-gauge-card:nth-child(n+3) {
  margin-bottom: 8px;
}
.mobile-gauge-text {
  font-size: 13px;
  font-weight: 700;
}
.mobile-gauge-label {
  font-size: 13px;
  text-align: center;
}
.mobile-subject-toggle {
  display: flex;
  flex-wrap: wrap;
}
.mobile-subject-pill {
  border-color: var(--gray-03) !important;
  color: rgba(0, 0, 0, 0.6) !important;
  background: #ffffff !important;
}
.mobile-subject-pill--active {
  border-color: #3F41D1 !important;
  background: #3F41D129 !important;
  color: #3F41D1 !important;
}
.mobile-topic-name {
  font-family: "GraphikMedium", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.0125em;
  vertical-align: middle;
  color: #666666;
}
.mobile-video-card {
  border: 1px solid var(--gray-03);
}
.mobile-video-thumb-wrapper {
  position: relative;
  flex: 0 0 auto;
}
.mobile-video-thumb {
  border-radius: 8px;
}
.mobile-video-play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.85) !important;
}
.mobile-video-info {
  flex: 1 1 auto;
  min-width: 0;
}
.mobile-video-name {
  max-width: 140px;
}
.icon-size.v-icon {
    font-size: 24px !important;
}
.interview-remark{
    overflow: auto;
    color: rgba(0, 0, 0, 0.6);
    text-align: left;
    font-size: 12px;
    height: 11vh;
    scrollbar-width: none;
}
.subject-circular-progress-inner-text{
    color: black;
    font-size: 18.94px;
    font-weight: 500 !important;
    font-family: "GraphikMedium", sans-serif !important;
    line-height: 27.43px;
}
.subject-circular-progress-outer-text{
    color: black;
    font-size: 20px !important;
    font-weight: 400 !important;
    line-height: 22px;
}
.demo-text{
    font-family: "GraphikMedium";
    font-size: 14px;
}
.score-text{
    font-family: "GraphikMedium";
    font-size: 12px;
}
.active {
    color: #000000;
    background-color:  #C9C3B0;
    border-bottom: 3px solid #B2AC88;
}
.small-circular-progress-inner-outer-text{
  color: black;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 15.4px;
}
.user-profile-text{
    font-family: "GraphikMedium";
    font-size: 14px;
    font-weight: 500 !important;
    
}
.user-details-text{
    font-family: "GraphikMedium";
    font-size: 14px;
    font-weight: 400 !important;    
}
.v-progress-circular__overlay {
     stroke-linecap: round;
     
 }
.card {
    width: 300px;
    height: 200px;
    
    /*border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);*/
    }
.mainDiv {
    height: 100%;
    margin-top: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.video-wrapper {
  position: relative;
  display: inline-block;
}

.video-wrapper video {
  display: block;
}

.play-button {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
 
}
.large-screen {
    position: absolute;
    right:6px;
    bottom:7px;
    height: 10px !important;
    width: 10px;
}
.preview-video {
    min-height: 400px;
    height: 450px;
    object-fit: contain;
  }

  .fix-top-width{
    width: 99%;
  }

.thumbnain-ht{
       height: 60px;
    object-fit: cover;
}
.active-subject-tab{
    background-color: #CFD5F1;
    border-bottom: 3px solid #3F41D1;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}
.demo-segmented-control{
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}
</style>




